/* NEYSAN SHOP · mejoras pequeñas de la tienda (se carga en todas las páginas)
 *
 * 1) Foto según el color elegido
 *    Al tocar Blanco / Lima en "Elige tus colores", la galería del producto pasa a la
 *    primera foto cuyo texto alternativo contenga ese color (ej. "Ventilador lima").
 *
 * 2) "Comprar ahora" abre el formulario contra entrega (EasySell)
 *    Con la incrustación de EasySell activa, "Comprar ahora" abre su formulario emergente
 *    (EasySell reconoce la clase es-popup-button-overwrite). Si EasySell no está cargado,
 *    "Comprar ahora" sigue llevando al checkout.
 */
(function () {
  function norm(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{M}/gu, '')
      .trim();
  }

  function showColor(section, color) {
    var name = norm(color);
    if (!name) return;
    var track = section.querySelector('[data-track]');
    if (!track) return;
    var slides = section.querySelectorAll('[data-slide]');
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      var label = norm((img && img.getAttribute('alt')) || slides[i].getAttribute('data-alt'));
      if (label && (' ' + label + ' ').indexOf(name) !== -1) {
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        return;
      }
    }
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-color-input]')) return;
    var section = input.closest('.rzvni-pd');
    if (section) showColor(section, input.value);
  });
})();

(function () {
  /* EasySell abre su formulario al hacer clic en cualquier elemento con esta clase */
  var ES_CLASS = 'es-popup-button-overwrite';

  function easySellLoaded() {
    return !!document.querySelector('script[src*="7bfd0a95-6839-4f02-b2ee-896832dbe67e"], script[src*="easysell"], script[src*="tyslo"], link[href*="easysell"], link[href*="tyslo"]') ||
      !!document.querySelector('[class*="es-form"], [id*="es-form"], [class*="easysell"], [id*="easysell"]');
  }

  function proxyFor(section) {
    var proxy = section.querySelector('.rzvni-es-proxy');
    if (!proxy) {
      proxy = document.createElement('button');
      proxy.type = 'button';
      proxy.className = 'rzvni-es-proxy ' + ES_CLASS;
      proxy.setAttribute('aria-hidden', 'true');
      proxy.tabIndex = -1;
      proxy.style.cssText = 'position:absolute;width:1px;height:1px;opacity:0;pointer-events:none;overflow:hidden;';
      section.appendChild(proxy);
    }
    return proxy;
  }

  /* Formulario oculto estándar de Shopify (input name="id") para que EasySell
     sepa exactamente qué variante y cuántas unidades pide el cliente. */
  function productData(section) {
    var el = section.querySelector('[data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function formFor(section) {
    var form = section.querySelector('form.rzvni-es-form');
    if (!form) {
      form = document.createElement('form');
      form.method = 'post';
      form.action = '/cart/add';
      form.className = 'rzvni-es-form';
      form.setAttribute('data-type', 'add-to-cart-form');
      form.setAttribute('aria-hidden', 'true');
      form.style.display = 'none';
      form.innerHTML = '<input type="hidden" name="form_type" value="product">' +
        '<input type="hidden" name="id" value=""><input type="hidden" name="quantity" value="1">';
      section.appendChild(form);
    }
    return form;
  }

  function syncForm(section) {
    var data = productData(section);
    if (!data) return;
    var form = formFor(section);
    var fromUrl = new URL(window.location.href).searchParams.get('variant');
    var id = fromUrl && data.variants.some(function (v) { return String(v.id) === fromUrl; }) ? fromUrl : data.current;
    form.querySelector('[name="id"]').value = id;
    var offer = section.querySelector('[data-offer-input]:checked');
    form.querySelector('[name="quantity"]').value = offer ? offer.value : 1;
  }

  function prepare() {
    document.querySelectorAll('.rzvni-pd').forEach(function (section) {
      if (!section.querySelector('[data-buy-now]')) return;
      proxyFor(section);
      syncForm(section);
      /* La barra fija de abajo usa el mismo botón naranja y abre el mismo formulario */
      var stickyBtn = section.querySelector('[data-sticky-add]');
      if (stickyBtn && easySellLoaded()) stickyBtn.classList.add('rzvni-pd__btn--orange');
    });
  }

  document.addEventListener('change', function (event) {
    var section = event.target.closest && event.target.closest('.rzvni-pd');
    if (section) setTimeout(function () { syncForm(section); }, 0);
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-buy-now], [data-sticky-add]');
    if (!btn || !easySellLoaded()) return; /* sin EasySell: va al checkout como siempre */
    var section = btn.closest('.rzvni-pd');
    if (!section) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    syncForm(section);
    proxyFor(section).click();
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare);
  else prepare();
  window.addEventListener('load', prepare);
  document.addEventListener('shopify:section:load', prepare);

  /* Oculta el botón fijo propio de EasySell: la barra fija del producto ya abre el formulario */
  var esCss = document.createElement('style');
  esCss.textContent = 'body:has(.rzvni-pd [data-sticky-add]) #es-sticky{display:none !important;}';
  document.head.appendChild(esCss);
})();

(function () {
  /* 3) Botón "volver arriba": aparece al bajar, con anillo que muestra cuánto has recorrido */
  if (document.querySelector('.rzvni-top')) return;
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'rzvni-top';
  btn.setAttribute('aria-label', 'Volver arriba');
  btn.innerHTML =
    '<svg class="rzvni-top__ring" viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="22" pathLength="100"/></svg>' +
    '<svg class="rzvni-top__arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V5M5.5 11.5 12 5l6.5 6.5"/></svg>';
  document.body.appendChild(btn);
  var style = document.createElement('style');
  style.id = 'rzvni-top-css';
  style.textContent = "/* ── Botón \"volver arriba\": encima del botón de WhatsApp, con anillo de progreso ── */\n.rzvni-top {\n  position: fixed;\n  right: 21px;\n  bottom: calc(82px + env(safe-area-inset-bottom));\n  z-index: 14;\n  display: grid;\n  place-items: center;\n  width: 44px;\n  height: 44px;\n  padding: 0;\n  color: #f2f2f2;\n  background: rgb(12 12 13 / 0.78);\n  border: 1px solid rgb(255 255 255 / 0.12);\n  border-radius: 50%;\n  box-shadow: 0 10px 28px rgb(0 0 0 / 0.45);\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  cursor: pointer;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(12px) scale(0.9);\n  transition: opacity 0.3s ease, transform 0.35s cubic-bezier(0.2, 0.8, 0.2, 1), visibility 0.3s, bottom 0.3s ease, background 0.2s ease;\n  -webkit-tap-highlight-color: transparent;\n}\n.rzvni-top.is-visible { opacity: 1; visibility: visible; transform: none; }\n.rzvni-top__ring {\n  position: absolute;\n  inset: -1px;\n  width: calc(100% + 2px);\n  height: calc(100% + 2px);\n  transform: rotate(-90deg);\n  pointer-events: none;\n}\n.rzvni-top__ring circle {\n  fill: none;\n  stroke: #c8f560;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-dasharray: 100;\n  stroke-dashoffset: 100;\n  transition: stroke-dashoffset 0.12s linear;\n}\n.rzvni-top__arrow {\n  width: 18px;\n  height: 18px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  transition: transform 0.25s ease;\n}\n@media (hover: hover) {\n  .rzvni-top:hover { background: rgb(28 28 30 / 0.9); }\n  .rzvni-top:hover .rzvni-top__arrow { transform: translateY(-2px); }\n}\n.rzvni-top:focus-visible { outline: 2px solid #c8f560; outline-offset: 3px; }\n@media (max-width: 749px) {\n  .rzvni-top { right: 20px; bottom: calc(80px + env(safe-area-inset-bottom)); }\n}\n/* Sube junto con WhatsApp cuando aparece la barra de compra fija del producto */\nbody:has(.rzvni-pd__sticky.is-visible) .rzvni-top { bottom: calc(150px + env(safe-area-inset-bottom)); }\n/* Sin botón de WhatsApp, baja a la esquina */\nbody:not(:has(.rzvni-wa)) .rzvni-top { bottom: calc(16px + env(safe-area-inset-bottom)); }\nbody:not(:has(.rzvni-wa)):has(.rzvni-pd__sticky.is-visible) .rzvni-top { bottom: calc(84px + env(safe-area-inset-bottom)); }\n@media (prefers-reduced-motion: reduce) {\n  .rzvni-top, .rzvni-top__ring circle, .rzvni-top__arrow { transition: none; }\n}";
  document.head.appendChild(style);
  var ring = btn.querySelector('.rzvni-top__ring circle');
  var ticking = false;

  function update() {
    ticking = false;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var y = window.scrollY || window.pageYOffset;
    btn.classList.toggle('is-visible', y > Math.min(600, window.innerHeight * 0.8));
    ring.style.strokeDashoffset = String(100 - (max > 0 ? Math.min(1, y / max) : 0) * 100);
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('resize', update);

  btn.addEventListener('click', function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });

  update();
})();

(function () {
  /* 4) Redes del footer con su logo y color de marca */
  var ICONS = {
    instagram: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5.5" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="4.2" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="17.4" cy="6.6" r="1.3" fill="currentColor"/></svg>',
    facebook: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M13.5 21v-7.6h2.6l.4-3h-3V8.5c0-.9.3-1.5 1.6-1.5h1.6V4.3c-.3 0-1.2-.1-2.3-.1-2.3 0-3.9 1.4-3.9 4v2.2H7.9v3h2.6V21h3Z"/></svg>',
    tiktok: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M16.6 3c.3 2.2 1.6 3.6 3.8 3.8v3a7 7 0 0 1-3.7-1.2v6.1a5.8 5.8 0 1 1-5.8-5.8c.3 0 .6 0 .9.1v3.1a2.8 2.8 0 1 0 1.9 2.6V3h2.9Z"/></svg>'
  };

  function brand(href) {
    href = String(href || '').toLowerCase();
    if (href.indexOf('instagram.') !== -1) return 'instagram';
    if (href.indexOf('facebook.') !== -1 || href.indexOf('fb.') !== -1) return 'facebook';
    if (href.indexOf('tiktok.') !== -1) return 'tiktok';
    return '';
  }

  function decorate(root) {
    (root || document).querySelectorAll('.rzvni-ft__social-link:not([data-brand])').forEach(function (a) {
      var b = brand(a.getAttribute('href'));
      if (!b) return;
      a.setAttribute('data-brand', b);
      a.setAttribute('aria-label', a.textContent.trim() + ' de NEYSAN SHOP');
      a.innerHTML = '<span class="rzvni-soc__icon">' + ICONS[b] + '</span><span class="rzvni-soc__name">' + a.textContent.trim() + '</span>';
    });
  }

  var css = document.createElement('style');
  css.id = 'rzvni-social-css';
  css.textContent = [
    '.rzvni-ft__social{gap:10px !important}',
    '.rzvni-ft__social .rzvni-ft__social-link[data-brand]{display:inline-flex !important;align-items:center;gap:9px;min-height:44px;padding:0 16px 0 6px !important;font-size:.8125rem !important;font-weight:600 !important;letter-spacing:0 !important;text-transform:none !important;color:#fff !important;text-decoration:none;border:0 !important;border-radius:999px !important;background:#151617 !important;box-shadow:inset 0 0 0 1px rgb(255 255 255 / .08);transition:transform .2s ease, box-shadow .2s ease}',
    '.rzvni-soc__icon{display:grid;place-items:center;width:32px;height:32px;border-radius:50%;color:#fff}',
    '.rzvni-soc__icon svg{width:18px;height:18px}',
    '[data-brand="instagram"] .rzvni-soc__icon{background:radial-gradient(circle at 30% 107%,#fdf497 0%,#fdf497 5%,#fd5949 45%,#d6249f 60%,#285aeb 90%)}',
    '[data-brand="facebook"] .rzvni-soc__icon{background:#1877f2}',
    '[data-brand="tiktok"] .rzvni-soc__icon{background:#000;box-shadow:-1.5px -1px 0 #25f4ee inset,1.5px 1px 0 #fe2c55 inset}',
    '[data-brand="instagram"]:hover{box-shadow:inset 0 0 0 1px rgb(214 36 159 / .6) !important}',
    '[data-brand="facebook"]:hover{box-shadow:inset 0 0 0 1px rgb(24 119 242 / .7) !important}',
    '[data-brand="tiktok"]:hover{box-shadow:inset 0 0 0 1px rgb(37 244 238 / .6) !important}',
    '@media (hover:hover){.rzvni-ft__social .rzvni-ft__social-link[data-brand]:hover{transform:translateY(-2px)}}'
  ].join('\n');
  document.head.appendChild(css);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { decorate(); });
  else decorate();
  document.addEventListener('shopify:section:load', function (e) { decorate(e.target); });
})();

(function () {
  /* 5) Corrige textos del tema sin tilde (ej. "Tu carrito esta vacío") */
  var FIXES = [[/\besta vacío\b/g, 'está vacío']];
  var busy = false;
  function fix(root) {
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var t = node.nodeValue;
      if (t.indexOf('esta vac') === -1) continue;
      FIXES.forEach(function (f) { t = t.replace(f[0], f[1]); });
      if (t !== node.nodeValue) node.nodeValue = t;
    }
  }
  function run() { if (busy) return; busy = true; requestAnimationFrame(function () { fix(); busy = false; }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  if ('MutationObserver' in window) new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
